// Shared Notion logo mark. Uses /notion-logo.png from the public folder.
// Mirrors the OneDriveLogo pattern (height-driven, auto width).
const NotionLogo = ({ size = 24, style = {} }) => (
  <img src="/notion-logo.png" alt="Notion" style={{ height: size, width: 'auto', ...style }} />
);

export default NotionLogo;
